import Visibility from "@mui/icons-material/Visibility";
import { IconButton, Tooltip } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { UUID } from "../../../../utils/uuid";

export const ViewAction: FC<{
  id: UUID | null;
  title: string | null;
  follow_up_id?: UUID | null;
}> = ({ id, title, follow_up_id }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("View Communication: {{title}}", { title })}>
      <IconButton
        data-analytics-id="moment-card-view"
        href={follow_up_id ? `/follow-up/${follow_up_id}` : `/moments/${id || ""}`}
      >
        <Visibility fontSize="small" sx={{ marginLeft: 0 }} data-testid="moment-view-icon" />
      </IconButton>
    </Tooltip>
  );
};
